export default __webpack_public_path__ + "static/media/dummyad.bd962dfc0db4e02219bfdfd3d2f75e92.jpg";